
    <form [formGroup]="profileForm">
    
        <div>
          <mat-form-field [style.width.px]=300>
            <mat-label i18n>Username</mat-label>
            <input matInput formControlName="username" required>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field [style.width.px]=300 >
            <mat-label i18n>Inventory location country</mat-label>
            <select-country 
                formControlName="country"
                [required]="true"/>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field [style.width.px]=300 >
            <mat-label i18n>Inventory location city</mat-label>
            <select-location
                formControlName="location"
                [countryCode]="selectedCountryCode"
                [required]="true"/>
          </mat-form-field>
        </div>
        
    </form>
